import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import '@angular/compiler';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from "ag-grid-enterprise";
import * as echarts from 'echarts';

const agGridLicenseKey = environment.agGridLicenseKey?.trim();
if (agGridLicenseKey) {
  LicenseManager.setLicenseKey(agGridLicenseKey);
}

echarts.registerTheme('customTheme', {
  title: {
    textStyle: {
      color: 'white',
    },
  },
  color: [
    '#fffdcf', '#ff7070', '#d4fc88', '#ff63fe', '#ffb026', '#ffc5ab',
    '#c2da46', '#ff825b', '#ff6188', '#cfa07c', '#a3d67e', '#ffe10f',
    '#d9b6cd', '#ffe278', '#80ffc6',
  ],
  xAxis: {
    axisLabel: {
      color: 'white',
    },
  },
  yAxis: {
    axisLabel: {
      color: 'white',
    },
  },
  tooltip: {
    backgroundColor: '#333',
    textStyle: {
      color: '#fff',
    },
  },
});

// Enable production mode
if (environment.production) {
  enableProdMode();

  // GDPR / ISO 27701: suppress verbose client-side logging in production so that
  // PII (user objects, JWT payloads, emails) is never written to the browser console.
  // console.error / console.warn are preserved for operational diagnostics.
  const noop = () => {};
  console.log = noop;
  console.debug = noop;
  console.info = noop;
}

// Bootstrap the Angular application
platformBrowserDynamic().bootstrapModule(AppModule)
  .catch(err => console.error(err));
